/**
 * @link https://mui.com/material-ui/react-checkbox/
 */

import { Checkbox, Divider, FormControlLabel, FormGroup, Typography } from "@mui/material";

/**
 * Import extra Icons
 */
import FavoriteBorder from "@mui/icons-material/FavoriteBorder";
import Favorite from "@mui/icons-material/Favorite";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import React from "react";
import ShowCode from "../../helpers/ShowCode.js";

/**
 * Set Some default Props
 */
const label = { inputProps: { "aria-label": "Checkbox demo", "label": 'Demo Label' } };

export default function FactureeCheckbox() {
  return (
    <>
      <Typography>Small (default)</Typography>
      <Checkbox {...label} sx={{paddingLeft: 0}} defaultChecked/>
      <Checkbox {...label} sx={{paddingLeft: 0}} />
      <Checkbox {...label} sx={{paddingLeft: 0}} disabled />
      <Checkbox {...label} sx={{paddingLeft: 0}} disabled checked />
      <br/>
      <br/>

      <Typography>Medium</Typography>
      <Checkbox {...label} sx={{paddingLeft: 0}} size="medium" defaultChecked/>
      <Checkbox {...label} sx={{paddingLeft: 0}} size="medium" />
      <Checkbox {...label} sx={{paddingLeft: 0}} size="medium" disabled />
      <Checkbox {...label} sx={{paddingLeft: 0}} size="medium" disabled checked />
      <br/>
      <br/>

      <Typography>Large</Typography>
      <Checkbox {...label} sx={{paddingLeft: 0}} size="large" defaultChecked/>
      <Checkbox {...label} sx={{paddingLeft: 0}} size="large" />
      <Checkbox {...label} sx={{paddingLeft: 0}} size="large" disabled />
      <Checkbox {...label} sx={{paddingLeft: 0}} size="large" disabled checked />
      <br/>
      <br/>

      <Divider textAlign={"left"}><Typography variant={"h6"}>Checkbox grouped</Typography></Divider>

      <FormGroup sx={{paddingLeft: '3px'}}>
        <FormControlLabel control={<Checkbox defaultChecked />} label="Active checked" />
        <FormControlLabel control={<Checkbox />} label="Active" />
        <FormControlLabel control={<Checkbox disabled />} label="Disabled" />
        <FormControlLabel control={<Checkbox disabled checked />} label="Disabled checked" />
      </FormGroup>

      <Divider textAlign={"left"}><Typography variant={"h6"}>Iconed Checkbox</Typography></Divider>

      <Checkbox
        {...label}
        icon={<FavoriteBorder />}
        checkedIcon={<Favorite />}
        color="secondary"
      />
      <Checkbox
        {...label}
        icon={<BookmarkBorderIcon />}
        checkedIcon={<BookmarkIcon />}
      />

      <br/>
      <br/>
      
      <ShowCode 
        codeString={`<>
  {/* Basic Checkboxes */}
  <Typography>Basic Checkboxes</Typography>
  <Checkbox defaultChecked />
  <Checkbox />
  <Checkbox disabled />
  <Checkbox disabled checked />
  
  {/* Different Sizes */}
  <Typography>Different Sizes</Typography>
  <Checkbox size="small" />
  <Checkbox size="medium" />
  <Checkbox size="large" />
  
  {/* Checkbox Group */}
  <FormGroup>
    <FormControlLabel control={<Checkbox defaultChecked />} label="Option 1" />
    <FormControlLabel control={<Checkbox />} label="Option 2" />
    <FormControlLabel control={<Checkbox disabled />} label="Disabled" />
  </FormGroup>
  
  {/* Custom Icon Checkboxes */}
  <Typography>Custom Icons</Typography>
  <Checkbox
    icon={<FavoriteBorder />}
    checkedIcon={<Favorite />}
    color="secondary"
  />
  <Checkbox
    icon={<BookmarkBorderIcon />}
    checkedIcon={<BookmarkIcon />}
  />
</>`} 
        scope={{ 
          React, 
          Checkbox, 
          Typography, 
          FormGroup, 
          FormControlLabel, 
          FavoriteBorder, 
          Favorite, 
          BookmarkBorderIcon, 
          BookmarkIcon 
        }} 
      />
    </>
  )
}